export const messages = {
  en: {
    carAddParkingSpace: {
      vehicleInfo: 'Vehicle Information',
      licensePlate: 'License Plate',
      requiredLicensePlate: 'Required, please fill in the license plate',
      startTime: 'Start Time',
      requiredStartTime: 'Required, please fill in the start time',
      endTime: 'End Time',
      requiredEndTime: 'Required, please fill in the end time',
      remark: 'Remark',
      remarkPlaceholder: 'Please fill in remarks',
      submit: 'Submit',
      parkingSpaceInfo: 'Parking Space Information',
      parkingSpaceId: 'Parking Space ID',
      number: 'Number',
      parkingLot: 'Parking Lot',
      parkingSpaceStatus: 'Parking Space Status',
      area: 'Area',
      squareMeters: 'square meters',
      remarks: 'Remarks',
      selectParkingSpace: 'Select Parking Space',
      search: 'Search',
      reset: 'Reset',
      parkingLotCode: 'Parking Lot Code',
      parkingSpaceCode: 'Parking Space Code',
      parkingLotType: 'Parking Lot Type',
      parkingSpaceType: 'Parking Space Type',
      operation: 'Operation',
      select: 'Select',
      aboveGround: 'Above Ground',
      underground: 'Underground',
      free: 'Free',
      sold: 'Sold',
      rented: 'Rented',
      unknown: 'Unknown'
    }
  },
  zh: {
    carAddParkingSpace: {
      vehicleInfo: '车辆信息',
      licensePlate: '车牌号',
      requiredLicensePlate: '必填，请填写车牌号',
      startTime: '起租时间',
      requiredStartTime: '必填，请填写起租时间',
      endTime: '结租时间',
      requiredEndTime: '必填，请填写结租时间',
      remark: '备注',
      remarkPlaceholder: '请填写备注信息',
      submit: '提交',
      parkingSpaceInfo: '停车位信息',
      parkingSpaceId: '车位ID',
      number: '编号',
      parkingLot: '停车场',
      parkingSpaceStatus: '车位状态',
      area: '面积',
      squareMeters: '平方米',
      remarks: '备注',
      selectParkingSpace: '选择车位',
      search: '查询',
      reset: '重置',
      parkingLotCode: '停车场编码',
      parkingSpaceCode: '停车位编码',
      parkingLotType: '停车场类型',
      parkingSpaceType: '车位类型',
      operation: '操作',
      select: '选择',
      aboveGround: '地上停车位',
      underground: '地下停车位',
      free: '空闲',
      sold: '已售卖',
      rented: '已出租',
      unknown: '未知'
    }
  }
}